import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  nameFieldsContainer: {
    gap: theme.spacing[4],
  },
}));
